import SectionHead from './SectionHead';
import { glossary } from '@/mocks/meihei';

export default function GlossarySection() {
  return (
    <section id="cidian" className="anchor-target bg-honey-50/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHead
            eyebrow="概念速查 · 词条手册"
            title="热搜黑话速查，看到不再懵"
            desc="把吃瓜路上最常碰到的词条一次性收进小手册。传播学词汇 + 平台机制，看完心里更有谱。"
          />
          <a
            href="#faq"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-[13px] font-semibold text-ember-600 hover:text-ember-500"
          >
            还有疑问？看常见问答
            <i className="ri-arrow-down-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {glossary.map((g) => (
            <article key={g.term} className="flex flex-col rounded-xl border border-honey-200/70 bg-paper p-5">
              <div className="flex items-center justify-between gap-3">
                <h3 className="display text-base font-bold text-ink">{g.term}</h3>
                <span className="whitespace-nowrap rounded-full bg-honey-100 px-2.5 py-0.5 text-[11px] font-semibold text-honey-500">
                  {g.type}
                </span>
              </div>
              <p className="mt-3 flex-1 text-[13px] leading-relaxed text-clay">{g.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}